import { FC } from "react";
import { AppPartType } from "../../../types";
import { Checkbox } from "antd";

type Prop = {
  appPart: AppPartType;
};
const CheckBox: FC<Prop> = ({
  appPart: { default_value, item_config_data },
}) => {
  const listOptions =
    Array.isArray(item_config_data?.options) &&
    item_config_data?.options?.length > 0
      ? item_config_data?.options
      : [
          { text: "サンプル1", value: "サンプル1" },
          { text: "サンプル2", value: "サンプル2" },
        ];
  return (
    <div
      className={`options-container ${
        item_config_data.layout === "vertical" ? "" : "is-horizontal"
      }`}
    >
      {listOptions.map((option, index) => (
        <label key={`${option.text}_${index}`} className="option">
          <Checkbox checked={option?.default_checked}></Checkbox>
          <span className="option-label" style={{ marginLeft: 5 }}>
            {option.text}
          </span>
        </label>
      ))}
    </div>
  );
};

export default CheckBox;
